import { Box, Button, ButtonGroup, Card, CardContent, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import SimpleLineChart from "../../components/lineChart";
import React, { useState } from "react";

export default function DailyActivityReportLineChart({ activeList, changeFilter, filter }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [selectedFilter, setSelectedFilter] = useState("day");
  return (
    <Stack
      direction={isMobile ? "column" : "row"}
      spacing={2}
      sx={{ mt: 4, marginRight: 2 }}
    >
      <Box sx={{ flex: 1 }}>
        <Card
          sx={{
            flex: 1,
            borderRadius: 3,
            boxShadow: 2,
            backgroundColor: "background.main",
          }}
        >
          <CardContent>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                {/* <Typography variant="body2" color="grey" gutterBottom>
                    Statistics
                    </Typography> */}
                <Typography variant="subtitle" fontWeight="bold">
                  Daily Active Report
                </Typography>
              </Box>

            <ButtonGroup variant="contained" aria-label="filter group">
                <Button onClick={() => changeFilter("day")}
                     sx={{
                        backgroundColor: filter === 'day' ? "primary.main" : "transparent",
                        color: filter === 'day' ? "#fff" : "primary.main" ,
                        '&:hover': { backgroundColor: "primary.dark", color: "#fff" }
                    }}>
                        Day
                </Button>
                <Button onClick={() => changeFilter("weekly")}
                     sx={{
                         backgroundColor: filter === 'weekly' ? "primary.main" : "transparent",
                        color: filter === 'weekly' ? "#fff" : "primary.main",
                        '&:hover': { backgroundColor: "primary.dark", color: "#fff" }
                    }}>
                        Weekly
                </Button>
                <Button onClick={() => changeFilter("monthly")}
                     sx={{
                         backgroundColor: filter === 'monthly' ? "primary.main" : "transparent",
                        color: filter === 'monthly' ? "#fff" : "primary.main",
                        '&:hover': { backgroundColor: "primary.dark", color: "#fff" }
                    }}>
                        Monthly
                </Button>
              </ButtonGroup>

            </Stack>
            <SimpleLineChart data={activeList} updateFilter={changeFilter} />
          </CardContent>
        </Card>
      </Box>
    </Stack>
  );
}
